module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-01.9aefb14.jpg";